<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-journal-medical fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Consultations</h2>
      </div>
      <!--<button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation">
        <i class="bi bi-plus-circle me-1"></i> Nouvelle Consultation
      </button>-->
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input v-model="searchQuery" placeholder="Nom, téléphone, type, médecin..." class="form-control form-control-clinique" />
        </div>

        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Médecin</label>
          <select v-model="selectedMedecin" class="form-select form-select-clinique">
            <option value="">Tous les médecins</option>
            <option v-for="m in medecinsDisponibles" :key="m.id" :value="m.id">
              {{ m.nom }} ({{ m.count }})
            </option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Du</label>
          <input type="date" v-model="dateDebut" class="form-control form-control-clinique" />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Au</label>
          <input type="date" v-model="dateFin" class="form-control form-control-clinique" />
        </div>

        <div class="col-6 col-md-2 d-flex align-items-end">
          <button
            class="btn btn-outline-secondary w-100"
            @click="resetPeriode"
            :disabled="!dateDebut && !dateFin"
          >
            <i class="bi bi-x-circle me-1"></i> Effacer
          </button>
        </div>
      </div>

      <div class="row g-3 align-items-end mt-1">
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Raccourcis période</label>
          <select v-model="periodeRapide" class="form-select form-select-clinique" @change="appliquerPeriodeRapide">
            <option value="">— Choisir —</option>
            <option value="today">Aujourd'hui</option>
            <option value="week">Cette semaine</option>
            <option value="month">Ce mois</option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Erreur -->
    <div v-if="loadError" class="alert alert-danger d-flex justify-content-between align-items-center">
      <span>Impossible de charger les consultations.</span>
      <button class="btn btn-sm btn-outline-danger" @click="getConsultations">Réessayer</button>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des consultations...</p>
    </div>

    <!-- Tableau moderne -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto" :class="{ 'opacity-50': isFetching }">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>N° Consultation</th>
              <th>Date</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th class="d-none d-sm-table-cell">Téléphone</th>
              <th class="d-none d-md-table-cell">Type</th>
              <th class="d-none d-md-table-cell">Médecin</th>
              <th class="d-none d-md-table-cell">Paiement</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(consultation, index) in paginatedConsultations" :key="consultation.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ consultation.numConsultation }}</td>
              <td>{{ formatDate(consultation.createdAt) }}</td>
              <td>{{ consultation.patient_nom }}</td>
              <td>{{ consultation.patient_prenom }}</td>
              <td class="d-none d-sm-table-cell">{{ consultation.patient_telephone || '—' }}</td>
              <td class="d-none d-md-table-cell">{{ consultation.type_nom || '—' }}</td>
              <td class="d-none d-md-table-cell">
                <span v-if="consultation.medecin_nom">
                  Dr. {{ consultation.medecin_nom }} {{ consultation.medecin_prenom }}
                </span>
                <span v-else class="text-muted">—</span>
              </td>
              <td class="d-none d-md-table-cell">
                <span :class="consultation.estPaye === 'Payé' ? 'text-success' : 'text-warning'">
                  {{ consultation.estPaye || '—' }}
                </span>
              </td>
              <td>
                <span :class="consultation.statut === 'Terminée' ? 'text-success' : 'text-danger'">
                  {{ consultation.statut || '—' }}
                </span>
              </td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('PATIENT_DOSSIER')">
                      <a class="dropdown-item" @click="dossier(consultation.patient_id)">Dossier</a>
                    </li>
                     <li v-if="$store.getters.hasPermission('CONSULT_TRAITER')">
                      <a class="dropdown-item" @click="traiterConsultation(consultation)">Traitement</a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="paginatedConsultations.length === 0">
              <td colspan="11" class="text-center py-3">Aucune consultation disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center p-3 flex-wrap gap-2">
        <small class="text-muted">
          <span v-if="selectedMedecin">
            <strong>{{ filteredConsultations.length }}</strong> consultation(s) pour
            <strong>{{ medecinSelectionneNom }}</strong>
          </span>
          <span v-else>
            {{ filteredConsultations.length }} consultation(s)
          </span>
          <span v-if="dateDebut || dateFin">
            — période {{ dateDebut || '…' }} → {{ dateFin || '…' }}
          </span>
          <span v-if="searchQuery"> (recherche active, sur {{ consultations.length }} au total)</span>
        </small>

        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFetching: false,
      isFirstLoad: true,
      loadError: false,

      searchQuery: '',
      selectedMedecin: '', // '' = tous les médecins

      // Filtre période (format YYYY-MM-DD, comme les <input type="date">)
      dateDebut: '',
      dateFin: '',
      periodeRapide: '',

      itemsperpage: 50,
      orderBy: 'co.createdAt',
      sortOrder: 'DESC',

      // Liste COMPLETE chargée une fois : la recherche et la pagination
      // se font ensuite entièrement côté client (même pattern que
      // ListePatient.vue), puisque le paramètre `search` envoyé au
      // serveur n'était pas garanti d'être traité par le contrôleur.
      consultations: [],
      currentPage: 1,

      itemsPerPageT: [50, 100, 150, 200],
      orderByTabs: { Date: 'co.createdAt', Statut: 'co.statut' },
      sortOrders: { Croissant: 'ASC', Décroissant: 'DESC' },

      _searchTimeout: null
    };
  },
  computed: {

    /* =====================================================
       LISTE UNIQUE DES MÉDECINS (à partir des consultations
       chargées), avec le nombre de consultations par médecin.
       Ce compteur se recalcule automatiquement en fonction de
       la période sélectionnée (mais pas du médecin lui-même,
       pour permettre de voir tous les médecins disponibles).
    ====================================================== */
    medecinsDisponibles() {
      const map = new Map();
      const base = this.consultationsFiltreesParPeriode;

      base.forEach(c => {
        if (c.medecin_id) {
          if (!map.has(c.medecin_id)) {
            map.set(c.medecin_id, {
              id: c.medecin_id,
              nom: `Dr. ${c.medecin_nom || ''} ${c.medecin_prenom || ''}`.trim(),
              count: 0
            });
          }
          map.get(c.medecin_id).count++;
        }
      });

      return Array.from(map.values()).sort((a, b) => a.nom.localeCompare(b.nom));
    },

    medecinSelectionneNom() {
      const m = this.medecinsDisponibles.find(m => m.id === this.selectedMedecin);
      return m ? m.nom : '';
    },

    /* =====================================================
       ÉTAPE 1 : filtre par période uniquement
       (réutilisé par medecinsDisponibles ci-dessus pour que
       les compteurs par médecin reflètent la période choisie)
    ====================================================== */
    consultationsFiltreesParPeriode() {
      if (!this.dateDebut && !this.dateFin) return this.consultations;

      const debut = this.dateDebut ? dayjs(this.dateDebut).startOf('day') : null;
      const fin = this.dateFin ? dayjs(this.dateFin).endOf('day') : null;

      return this.consultations.filter(c => {
        const d = dayjs(c.createdAt);
        if (debut && d.isBefore(debut)) return false;
        if (fin && d.isAfter(fin)) return false;
        return true;
      });
    },

    /* =====================================================
       ÉTAPE 2 : filtrage complet côté client sur la liste
       déjà réduite par période (médecin + recherche texte)
    ====================================================== */
    filteredConsultations() {
      let liste = this.consultationsFiltreesParPeriode;

      // Filtre par médecin
      if (this.selectedMedecin) {
        liste = liste.filter(c => c.medecin_id === this.selectedMedecin);
      }

      // Filtre texte
      if (this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase();

        liste = liste.filter(c => {
          const nom = (c.patient_nom || '').toLowerCase();
          const prenom = (c.patient_prenom || '').toLowerCase();
          const telephone = (c.patient_telephone || '').toLowerCase();
          const type = (c.type_nom || '').toLowerCase();
          const medecin = `${c.medecin_nom || ''} ${c.medecin_prenom || ''}`.toLowerCase();
          const numConsultation = (c.numConsultation || '').toLowerCase();
          const statut = (c.statut || '').toLowerCase();

          return (
            nom.includes(q) ||
            prenom.includes(q) ||
            telephone.includes(q) ||
            type.includes(q) ||
            medecin.includes(q) ||
            numConsultation.includes(q) ||
            statut.includes(q)
          );
        });
      }

      return liste;
    },

    totalPages() {
      return Math.max(1, Math.ceil(this.filteredConsultations.length / this.itemsperpage));
    },

    paginatedConsultations() {
      const start = (this.currentPage - 1) * this.itemsperpage;
      return this.filteredConsultations.slice(start, start + this.itemsperpage);
    }
  },
  methods: {
    formatDate(date) { return date ? dayjs(date).format('DD-MM-YYYY HH:mm') : '—'; },

    dossier(id) {
      this.$router.push({ name: 'information_personnelle', params: { id: id } });
    },

    creation() { this.$router.push({ name: 'create_consultation' }); },

    resetPeriode() {
      this.dateDebut = '';
      this.dateFin = '';
      this.periodeRapide = '';
    },

    appliquerPeriodeRapide() {
      const aujourdHui = dayjs();

      if (this.periodeRapide === 'today') {
        this.dateDebut = aujourdHui.format('YYYY-MM-DD');
        this.dateFin = aujourdHui.format('YYYY-MM-DD');
      } else if (this.periodeRapide === 'week') {
        this.dateDebut = aujourdHui.startOf('week').format('YYYY-MM-DD');
        this.dateFin = aujourdHui.endOf('week').format('YYYY-MM-DD');
      } else if (this.periodeRapide === 'month') {
        this.dateDebut = aujourdHui.startOf('month').format('YYYY-MM-DD');
        this.dateFin = aujourdHui.endOf('month').format('YYYY-MM-DD');
      }
    },

    async getConsultations() {

      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      } else {
        this.isFetching = true;
      }

      this.loadError = false;

      try {
        // On charge TOUTE la liste (tri géré par le serveur), la
        // recherche/pagination/filtres médecin+période se font
        // ensuite côté client.
        const response = await api.getItems('consultations', {
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          itemsperpage: 100000
        });

        const { data } = response.data;
        this.consultations = data || [];
        this.currentPage = 1;

      } catch (error) {
        console.error('Erreur de chargement des consultations :', error);
        this.consultations = [];
        this.loadError = true;
      } finally {
        this.isLoading = false;
        this.isFetching = false;
      }
    },

    traiterConsultation(c) {
      if (c.statut === 'En attente' && c.estPaye === 'Non payé') {
        alert('Paiement requis');
      }
      else if (c.statut === 'Terminé') {
        alert('Consultation terminée');
      }
      else {
        this.$router.push({ name: 'traitement_consultation', params: { id: c.id } });
      }
    },

    changePage(page) {
      if (page > 0 && page <= this.totalPages && !this.isFetching) {
        this.currentPage = page;
      }
    }
  },
  watch: {

    searchQuery() {
      clearTimeout(this._searchTimeout);
      this._searchTimeout = setTimeout(() => {
        this.currentPage = 1;
      }, 300);
    },

    selectedMedecin() {
      this.currentPage = 1;
    },

    dateDebut() {
      this.currentPage = 1;
      // Si l'utilisateur modifie manuellement les dates, on
      // désactive le raccourci sélectionné pour éviter toute
      // confusion visuelle.
      this.periodeRapide = '';
    },

    dateFin() {
      this.currentPage = 1;
      this.periodeRapide = '';
    },

    itemsperpage() {
      this.currentPage = 1;
    },

    orderBy() {
      this.getConsultations();
    },

    sortOrder() {
      this.getConsultations();
    }
  },
  created() {
    this.getConsultations();
  },
  beforeUnmount() {
    clearTimeout(this._searchTimeout);
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 8px 12px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
.modern-table-clinique thead {
  background: linear-gradient(90deg, #8fd3f4, #0d6efd);
  color: #fff;
  font-weight: 600;
}
.modern-table-clinique tbody tr:hover {
  background-color: #e1f0ff;
  cursor: pointer;
  transition: all 0.3s ease;
}
.pagination-modern .page-link {
  border-radius: 50% !important;
  margin: 0 4px;
  min-width: 38px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d6efd;
  border: 1px solid #dee2e6;
}
.pagination-modern .page-item.active .page-link {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}
.pagination-modern .page-link:hover {
  background-color: #d1e7ff;
  transition: all 0.3s ease;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .table td, .table th {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
  }
  .btn-clinique {
    width: 100%;
  }
  .header-clinique {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>